export enum EPlatformNoticeAudienceType {
  AllRestaurants = "AllRestaurants",
  SelectedRestaurants = "SelectedRestaurants",
  AllCouriers = "AllCouriers",
  SelectedCouriers = "SelectedCouriers",
  AllResellers = "AllResellers",
  SelectedResellers = "SelectedResellers",
  CouriersAndResellers = "CouriersAndResellers",
  AllAudiences = "AllAudiences",
}
